import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { Group, GroupType } from '../../../../models/group.model';
import { UserModel } from '../../../../models/user.model';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import { AuthService } from '../../../../services/auth.service';
import { SearchService } from '../../../../services/search.service';
import * as memberActions from '../../../../state/actions/member.actions';
import { AppState } from '../../../../state/appstate';
import { AppOpenBannerComponent } from '../../../components/app-open-banner/app-open-banner.component';
import { BtnCallToActionComponent } from '../../../components/buttons/btn-call-to-action/btn-call-to-action.component';
import { DlgProfileUpdateComponent } from '../../../profile/dlg-profile-update/dlg-profile-update.component';

@Component({
  selector: 'app-group-invite',
  standalone: true,
  imports: [BtnCallToActionComponent, InitialsPipe, AppOpenBannerComponent],
  templateUrl: './group-invite.component.html',
  styleUrl: './group-invite.component.css',
})
export class GroupInviteComponent {
  private dialog: MatDialog = inject(MatDialog);
  router = inject(Router);
  auth = inject(AuthService);
  search = inject(SearchService);
  toastr = inject(ToastrService);
  store: Store<AppState> = inject(Store<AppState>);
  route: ActivatedRoute = inject(ActivatedRoute);

  groupId: string | null = null;
  group: Group | undefined | null;

  user: UserModel | undefined | null;

  isLoggedIn = this.auth.isAuthenticated();

  isLoading$: Observable<boolean> = new Observable();

  get appDeepLinkPath(): string | null {
    return this.groupId ? `links/groupinvite?groupId=${this.groupId}` : null;
  }

  constructor() {
    this.route.queryParamMap.subscribe((params) => {
      this.groupId = params.get('groupId');
      if (this.groupId) this.loadGroup();
    });

    this.store
      .select((state) => state.user.user)
      .subscribe((user) => {
        this.user = user;
      });

    this.isLoading$ = this.store.select((state) => state.members.inProgress);
  }

  async loadGroup() {
    this.group = await this.search.getGroupById(this.groupId!);
  }

  onJoinGroup() {
    const uid = this.auth.getUid();
    if (uid == null) {
      this.toastr.error(
        'Unable to fetch your login id. Please login again and try.',
        'Error fetching login id',
      );
      return;
    }

    // User profile details missing. Show dialog
    if (!this.user?.name) {
      let dialogConfig = new MatDialogConfig();
      const dialogRef = this.dialog.open(
        DlgProfileUpdateComponent,
        dialogConfig,
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.requestMembership(uid);
        }
      });
    } else {
      this.requestMembership(uid);
    }
  }

  private requestMembership(uid: string) {
    this.store.dispatch(
      memberActions.requestMembership({
        // group: this.group,
        group: {
          id: this.groupId!,
          groupType: GroupType.school,
        } as Group,
        uid: uid,
      }),
    );
  }

  onRegister() {
    const uid = this.auth.getUid();
    if (uid == null) {
      localStorage.setItem('redirectAfterLogin', this.router.url);
      // console.log(`Local storage set. Navigating to login page.`);
      this.router.navigate(['/auth/login']);
    }
  }
}
